import React, { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

const Email: React.FC<IconProps> = props => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g opacity='0.802362'>
      <rect x='1' y='3' width='14' height='10' rx='0.5' stroke='#878787' />
      <path
        d='M1.11793 12.1873C0.920111 12.38 0.915946 12.6965 1.10862 12.8943C1.3013 13.0921 1.61785 13.0963 1.81567 12.9036L1.11793 12.1873ZM5.08233 9.72181C5.28015 9.52913 5.28431 9.21258 5.09164 9.01477C4.89896 8.81695 4.58241 8.81279 4.38459 9.00546L5.08233 9.72181ZM14.1844 12.9036C14.3822 13.0963 14.6988 13.0921 14.8914 12.8943C15.0841 12.6965 15.08 12.38 14.8821 12.1873L14.1844 12.9036ZM11.6155 9.00546C11.4177 8.81279 11.1011 8.81695 10.9084 9.01477C10.7158 9.21258 10.7199 9.52913 10.9177 9.72181L11.6155 9.00546ZM1.81567 3.09642C1.61785 2.90374 1.3013 2.9079 1.10862 3.10572C0.915946 3.30353 0.920111 3.62009 1.11793 3.81276L1.81567 3.09642ZM7.67346 9.50004L7.32459 9.85822L7.65647 10.1815L8.00404 9.87517L7.67346 9.50004ZM14.864 3.82971C15.0712 3.64714 15.0912 3.33118 14.9086 3.12401C14.726 2.91684 14.4101 2.89689 14.2029 3.07947L14.864 3.82971ZM1.81567 12.9036L5.08233 9.72181L4.38459 9.00546L1.11793 12.1873L1.81567 12.9036ZM14.8821 12.1873L11.6155 9.00546L10.9177 9.72181L14.1844 12.9036L14.8821 12.1873ZM1.11793 3.81276L7.32459 9.85822L8.02233 9.14187L1.81567 3.09642L1.11793 3.81276ZM8.00404 9.87517L14.864 3.82971L14.2029 3.07947L7.34288 9.12492L8.00404 9.87517Z'
        fill='#878787'
      />
    </g>
  </svg>
)

export { Email }

export default Email
